import React, { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from '@/components/ui/command';
import { Button } from '@/components/ui/button';
import { Check, ChevronsUpDown } from 'lucide-react';

export const CatEventSelect = ({ catEvents, value, onChange, placeholder = 'None (optional)' }) => {
  const [open, setOpen] = useState(false);
  const selected = catEvents.find(e => e.cat_event_id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between font-normal bg-white"
          data-testid="cat-event-select"
        >
          <span className="truncate">
            {selected ? `${selected.cat_code} — ${selected.event_type} (${selected.event_date})` : placeholder}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 bg-white" align="start">
        <Command>
          <CommandInput placeholder="Search CAT events..." data-testid="cat-event-search-input" />
          <CommandList>
            <CommandEmpty>No CAT events found.</CommandEmpty>
            <CommandGroup>
              <CommandItem
                value="none-no-cat-event"
                onSelect={() => { onChange(''); setOpen(false); }}
                data-testid="cat-event-option-none"
              >
                <Check className={`mr-2 h-4 w-4 ${!value ? 'opacity-100' : 'opacity-0'}`} />
                None
              </CommandItem>
              {catEvents.map((event) => (
                <CommandItem
                  key={event.cat_event_id}
                  value={`${event.cat_code} ${event.event_type} ${event.event_date}`}
                  onSelect={() => { onChange(event.cat_event_id); setOpen(false); }}
                  data-testid={`cat-event-option-${event.cat_code}`}
                >
                  <Check className={`mr-2 h-4 w-4 ${value === event.cat_event_id ? 'opacity-100' : 'opacity-0'}`} />
                  {event.cat_code} — {event.event_type} ({event.event_date})
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
